import { Flex, Tabs, TabsProps } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// components

// services
import { isRTL } from 'core/services/language';
import PageTitle from 'components/title/title';
import BackButton from 'components/backButton/backButton';
import CapTableListPage from 'modules/main/companyInformation/capTable/pages/list';
import CompanyOverviewPage from 'modules/main/companyInformation/overview/pages/overview';
import CompanyDocumentsPage from 'modules/main/companyDocuments/pages/companyDocuments';
import ReviewDocumentComponent from 'modules/main/companyDocuments/components/reviewDocuments';

// styles

// models

const BusinessCompanyViewPage: FunctionComponent = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const tabItems: TabsProps['items'] = [
		{
			id: '1',
			key: 'overview',
			label: t('COMPANY_INFORMATION.OVERVIEW'),
			destroyInactiveTabPane: true,
			children: <CompanyOverviewPage />,
		},
		{
			id: '2',
			key: 'cap-table',
			label: t('COMPANY_INFORMATION.CAP_TABLE'),
			destroyInactiveTabPane: true,
			children: <CapTableListPage />,
		},
		{
			id: '3',
			key: 'DOCUMENT',
			label: t('COMPANY_INFORMATION.DOCUMENTS'),
			destroyInactiveTabPane: true,
			children: <ReviewDocumentComponent />,
		},
	];

	return (
		<>
			<PageTitle name={t('TITLE.COMPANY_INFORMATION')} />

			<BackButton />

			<Flex align="center" gap={10} className="my-3">
				{/* <img src={sample1} alt="sample" style={{ width: 60, height: 60, borderRadius: '50%' }} /> */}
				<div>
					<h5 className="mb-0">Company X</h5>
					<p className="text-light mb-0">Telecom</p>
				</div>
			</Flex>

			<Tabs defaultActiveKey="1" items={tabItems} size="large" direction={isRTL() ? 'rtl' : 'ltr'} />
		</>
	);
};

export default BusinessCompanyViewPage;
